import { lensProp } from "ramda"

export const lens = lensProp("router_state")
